<template>
  <template v-if="item">
    <UCard
      as="a"
      :ui="carouselCardFourWithoutBorder"
      :href="item.url"
      @click="sendGa4RecommendedClickEvent()"
    >
      <TLazyimg
        :sources="{ url: item.src }"
        :alt="item.name"
        :classes-img="cardLazyImgRounded"
        classes="aspect-w-3 aspect-h-2"
      />
      <template #footer>
        <TStars class="pb-1" :comments="item.numComments" :stars="item.rate" />

        <TText variant="semibold" size="base" classes="mb-0">
          {{ item.name }}
        </TText>

        <TText size="base" color="gray600" classes="mb-0">
          {{ item.zone }}
        </TText>
      </template>
    </UCard>
  </template>
</template>

<script setup lang="ts">
import type { CottageCard } from '../../entities/CottageCard'
import { sendGa4RecommendedClickEvent } from '~/modules/integrations/ga4/composables/useAnalyticsGa4Composable'
import { carouselCardFourWithoutBorder } from '~/modules/design-system/utils/nuxt-ui-config/components/card'
import { cardLazyImgRounded } from '~/modules/design-system/components/t-lazyimg/constants/config'

interface propsInterface {
  item: CottageCard | null
}

defineProps<propsInterface>()
</script>
